import React, { memo, useState } from "react";
import useIsMobile from '@/hooks/useIsMobile';
import ImagePickerContext from "../ImagePickerContext";
import ImageModal from "../ImagesModal";
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const ChatImagePickerContent = () => {
    const isMobile = useIsMobile(992);
    const viewModel = useComponent();

    return (
        <>
            {isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />}
            <ImageModal
                open={viewModel.isModalOpen}
                onOk={viewModel.handleLibraryOk}
                onCancel={viewModel.handleLibraryCancel}
            />
        </>
    );
};

const ChatImagePicker = ({
    value,
    maxPhotos = 10,
    acceptedFormats = ["image/jpeg", "image/png", "image/webp"],
    maxFileSize = 10485760,
    onChange,
    buttonSize = "small",
    buttonStyle,
    counterTextStyle,
}) => {
    const [folder, setFolder] = useState();

    return (
        <ImagePickerContext.Provider
            value={{ value, maxPhotos, acceptedFormats, maxFileSize, onChange, folder, setFolder, buttonSize, buttonStyle, counterTextStyle }}
        >
            <ChatImagePickerContent />
        </ImagePickerContext.Provider>
    );
};

export default memo(ChatImagePicker);